import { Component, Input, inject, type OnDestroy } from "@angular/core";
import type { Subscription } from "rxjs";
import type { Page } from "../../data-grid/grid-data.provider";
import type { HeaderRenderer } from "../../data-grid/header-renderer.interface";
import type { Corpus } from "@pienso/ingest-types/corpus.interface";
import { columnTypeDisplayNames } from "../../services/elastic-search.service";
import { FindReplaceService } from "./find-replace.service";

@Component({
  template: `
    <div class="datatable-header-cell-wrapper" [class.findCol]="column.prop === findCol">
      <span class="datatable-header-cell-label">{{column.name || '\u00a0'}}</span>
      <br/>
      <div class="typeDiv">
        <span class="typeText">{{column.dataType?.type ? COLUMN_TYPE_DISPLAY_NAMES[column.dataType.type] : ''}}</span>
      </div>
    </div>
  `,
  styleUrls: ["./find-replace-header-renderer.component.scss"],
})
export class FindReplaceHeaderRendererComponent implements HeaderRenderer, OnDestroy {
  service = inject(FindReplaceService);

  @Input() column: any;
  @Input() editable = true;
  @Input() corpus!: Corpus;
  @Input() page!: Page;

  COLUMN_TYPE_DISPLAY_NAMES = columnTypeDisplayNames;

  findCol: string | null = null;

  subscription: Subscription | null = null;

  constructor() {
    const service = this.service;

    this.subscription = service.columnId$.subscribe((colId) => (this.findCol = colId));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }
}
